import {
  MOCK_REQUIRED_DOCUMENTS_EMPLOYMENT,
  MOCK_REQUIRED_DOCUMENTS_JOURNAL_ENTRY,
} from '../mock-data/required-documents.mock';
import { createMockResponse } from '../mock.interceptor';

import type {
  RequiredDocumentsListApiResponse,
  ReviewType,
} from '../../features/evidence-files/required-documents.models';
import type { HttpResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';

/**
 * /projects/:projectId/required-documents へのリクエストをハンドリング
 * path はテナントプレフィックス除去済みの短縮パス
 */
export function handleRequiredDocumentsRequest(
  method: string,
  path: string,
  searchParams: URLSearchParams,
): Observable<HttpResponse<unknown>> | null {
  // GET /projects/:projectId/required-documents - 必要書類一覧取得
  const getRequiredDocumentsMatch =
    /^\/projects\/([^/]+)\/required-documents$/.exec(path);
  if (method === 'GET' && getRequiredDocumentsMatch) {
    const reviewType = searchParams.get('reviewType') as ReviewType | null;
    return handleGetRequiredDocuments(reviewType);
  }

  return null;
}

/**
 * GET /api/v0/tenants/:tenantId/projects/:projectId/required-documents - 必要書類一覧取得
 */
function handleGetRequiredDocuments(
  reviewType: ReviewType | null,
): Observable<HttpResponse<RequiredDocumentsListApiResponse>> {
  const items =
    reviewType === 'journal_entry'
      ? MOCK_REQUIRED_DOCUMENTS_JOURNAL_ENTRY
      : MOCK_REQUIRED_DOCUMENTS_EMPLOYMENT;
  return createMockResponse({ items, nextCursor: null });
}
